// extracted by mini-css-extract-plugin
module.exports = {"selector":"MobileSelect_selector__wJyC4","selectorHidden":"MobileSelect_selectorHidden__7DC7U"};